import { Component, Mixins, Watch } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import ExtButton from '@/components/ext/Button.vue';
import MapPageLayout, {
  Notification as MapNotification,
} from '@/components/page/map';
import { Yellow as FlexFilter } from '@/components/parts/filter';
import Common from '../common';
import Filter from '../filter';
import { Breadcrumbs } from '../types';
import {
  ACTION_FETCH,
  BREADCRUMBS_TEXT,
  EMPTY_TEXT,
  MAX_COUNT,
  ORGANIZATION_ROUTE,
  ORGANIZATIONS_MAP_ROUTE,
  PAGE_SEO_TITLE,
  PAGE_SIZE,
  SHOW_ALL_PARAM,
  SHOW_ALL_TEXT,
  STORE_MODULE_NAME,
} from './const';
import createStoreModule from './store';
import { getPoints } from './tools';
import { Items } from './types';
import {QueryParams} from "@/pages/profile/views/resultCourses/types";
import {Query} from "@/services";

const actions = mapActions(STORE_MODULE_NAME, [ACTION_FETCH]);
const fetch = actions[ACTION_FETCH];
const Organizations = namespace(STORE_MODULE_NAME);

@Component({
  components: {
    BreadcrumbsLayout,
    ExtButton,
    FlexFilter,
    MapNotification,
    MapPageLayout,
  },
  metaInfo: {
    title: PAGE_SEO_TITLE,
  },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
})
export default class PageOrganizationsMap extends Mixins(Common, Filter) {
  // Bindings
  @Organizations.State items: Items;
  @Organizations.State count: number;

  // Readonly
  readonly emptyText = EMPTY_TEXT;
  readonly routeName: string = ORGANIZATIONS_MAP_ROUTE;
  readonly organizationRouteName = ORGANIZATION_ROUTE;
  readonly showAllText = SHOW_ALL_TEXT;

  // Data
  isMounted: boolean = false;
  updating: boolean = false;

  // Computed
  get breadcrumbsExtended(): Breadcrumbs {
    return [...this.breadcrumbs, { text: BREADCRUMBS_TEXT }];
  }

  get filtered() {
    return this.updating ? 1 : (this.points && this.points.length) || 0;
  }

  get hasCoords() {
    return this.points.filter((point) => Array.isArray(point.coords));
  }

  get isLimited(): boolean {
    return this.$route.query.showAll !== SHOW_ALL_PARAM;
  }

  get showUnlimit(): boolean {
    return this.isLimited;
  }

  get points() {
    const { $router, items, isMounted } = this;
    if (!isMounted || !Array.isArray(items) || !items) return [];
    return items
      .reduce((sum, organization) => {
        const { id, logo, filials, name } = organization;
        const add = {
          image: {
            little: logo,
          },
          href: $router.resolve({
            name: ORGANIZATION_ROUTE,
            params: { id: String(id) },
          }).href,
        };
        const o = getPoints([organization]).map((item) => ({
          ...item,
          ...add,
        }));
        const f = getPoints(
          (filials || []).map((item, index) => ({
            ...item,
            name: item.name || [name, ' - Филиал № ', index + 1].join(''),
          })),
        ).map((item, index) => ({ ...item, ...add }));
        sum.push(...o, ...f);
        return sum;
      }, [] as Array<any>)
      .map((item, id) => ({ ...item, id: id + 1, __UPDATED__: true }));
  }

  get unlimitedRoute(): RawLocation {
    const { name, params, query } = this.$route;
    const result = {
      name,
      params,
      query: {
        ...query,
        showAll: SHOW_ALL_PARAM,
      },
    };
    return result;
  }

  // Watch
  @Watch('$route')
  onRouteChange() {
    this.update();
  }

  // Hooks
  mounted() {
    this.$nextTick(() => {
      this.isMounted = true;
      this.update();
    });
  }

  // Methods
  async update() {
    this.updating = true;
    const { $route, isLimited } = this;
    
    // TODO: вынести в общий набор типов QueryParams (много где будет использоваться)
    const query: QueryParams = {
      ...$route.query,
      showAll: $route.query.showAll,
      havingCoords: isLimited ? '1' : '',
      includeFilials: isLimited ? '0' : '1',
      limit: String(isLimited ? PAGE_SIZE : MAX_COUNT),
    };
    delete query.showAll;
    await fetch.call(this, query);
    this.updating = false;
  }

  updateEvents(ids: Array<any>) {
    return Promise.resolve(
      this.points.filter(({ id }) => ids.indexOf(id) !== -1),
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/organizations/map/script.ts